import { customList, CountryProperty } from 'country-codes-list'
import countryInfo from './CountryInfo.json'

const nameToCode = new Map<string,string>(Object.entries(customList('countryNameEn' as CountryProperty, "{countryCode}")))
const aliasToCode: Record<string, string> = {
    "USA": "US",
    "United States": "US",
}

nameToCode.set("Scotland", "GB-SCT")
nameToCode.set("England", "GB-ENG")
nameToCode.set("Wales", "GB-WLS")

// NOTE: do this AFTER adding extras above
const codeToName = new Map([...nameToCode.entries()].map(([name, code]) => [code, name]))

export interface LatLong {
    latitude: number
    longitude: number
}

export class GeoUtil {
    static getDistance(lat1: number, long1: number, lat2: number, long2: number) {
        const R = 6371 // radius of the earth in km
        const dLat = GeoUtil.degToRad(lat2-lat1)
        const dLon = GeoUtil.degToRad(long2-long1) 
        const a = 
            Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(GeoUtil.degToRad(lat1)) * Math.cos(GeoUtil.degToRad(lat2)) * 
            Math.sin(dLon/2) * Math.sin(dLon/2)
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
        const d = R * c // distance in km
        return d
    }

    static degToRad(deg: number) {
        return deg * (Math.PI/180)
    }

    static kmToMi(km: number) {
        return km * 0.621371
    }

    static getCountryName(placeName?: string) {
        return GeoUtil.getLevelName(placeName, 1)
    }

    static getCountryLocation(code: string) {
        const info = countryInfo.find(n => n.cca2 == code)
        return info ? { latitude: info.latlng[0], longitude: info.latlng[1] } as LatLong : undefined
    }

    static getLevelName(placeName: string | undefined, level: number) {
        if (placeName) {
            // could use split(',').at(-level).trim() but this is more efficient
            let stopIndex = placeName.length
            for (let i = 1; i <= level; i++) {
                const delimIndex = placeName.lastIndexOf(',', stopIndex - 1)
                const startIndex = delimIndex >= 0 ? delimIndex + 1 : 0

                if (i == level)
                    return placeName.substring(startIndex, stopIndex).trim()

                if (delimIndex < 0)
                    return undefined

                stopIndex = delimIndex
            }
        }        
    }

    static readonly LevelDelimiter = ", "
}

export class CountryCodes {
    static fromName(countryName: string | undefined) {
        if (!countryName)
            return undefined

        return nameToCode.get(countryName) ?? aliasToCode[countryName]
    }

    static toName(code: string | undefined) {
        return code ? codeToName.get(code) : undefined
    }
}